import { createContext, useEffect, useState } from "react";
import { getDetailsByEncryptedShortName } from "../services/projectService";

import storage from '../config/storage';
import { useParams } from "react-router-dom";

export const ProjectContext = createContext();

const ProjectContextProvider = ({ children }) => {
    const params = useParams();
    const [projectDetails, setProjectDetails] = useState(null);
    // True while project details are being fetched, so pages that depend on them (e.g. examMode) can wait instead of rendering with null
    const [projectLoading, setProjectLoading] = useState(!!params?.projectName);

    const setCurrentProjectDetails = async (projectShortName) => {
        try {
            if (projectShortName === null) {
                setProjectDetails(null);
                storage.clearProjectShortName();
                return;
            }
            setProjectLoading(true);
            const response = await getDetailsByEncryptedShortName(projectShortName);
            if (!response?.data?.id) {
                setProjectDetails(null);
                storage.clearProjectShortName();
                return;
            }
            setProjectDetails(response.data);
            storage.setProjectShortName(response.data.projectShortName)
        } catch (error) {
            console.log('There is an error while getting project details by short name', error);
            setProjectDetails(null);
            storage.clearProjectShortName();
        } finally {
            setProjectLoading(false);
        }
    }

    useEffect(() => {
        const projectEncryptedName = params?.projectName;
        if (projectEncryptedName){
            async function fetchData() {
                await setCurrentProjectDetails(projectEncryptedName);
            }
            fetchData();
        }
    }, []);

    return (
        <ProjectContext.Provider value={{ projectDetails, projectLoading, setCurrentProjectDetails }}>
            {children}
        </ProjectContext.Provider>
    );

}

export default ProjectContextProvider;